import React from 'react';

/**
 * LiteToggleSwitch — a small iOS-style toggle for the expanded controls panel.
 */
const LiteToggleSwitch = ({ checked, onChange }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    onClick={() => onChange(!checked)}
    className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors cursor-pointer ${
      checked ? 'bg-ag-green' : 'bg-ag-black-600'
    }`}
  >
    <span
      className={`inline-block h-3.5 w-3.5 rounded-full bg-white transition-transform ${
        checked ? 'translate-x-[18px]' : 'translate-x-[3px]'
      }`}
    />
  </button>
);

export default LiteToggleSwitch;
